<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Curadoria',
	title: 'Curadoria'
}
</script>

<style scoped>
</style>
